"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useMarkerEvents = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _react = require("react");
var _map = require("../../../lib/map.utils");
/**
 * Hook to manage marker events and update marker states accordingly.
 *
 * @param {Object} params - The parameters object
 * @param {Function} params.onMarkerClick - Callback function triggered when a marker is clicked
 * @param {boolean} params.enableAdvancedMarkers - Flag to enable advanced marker functionality
 * @param {Array} params.enabledLocationIds - Array of location IDs that are enabled
 * @param {Object} params.selectedLocation - Currently selected location object
 * @param {Object} params.gMaps - Google Maps API object
 * @param {Object} params.theme - Theme configuration object for marker styling
 * @param {Object} params.defaultMarkerIcon - Default icon configuration for markers
 * @param {React.MutableRefObject} params.keyboardFocusedMarkerRef - Ref object tracking keyboard-focused marker
 * @param {React.MutableRefObject} params.clickedMarkerRef - Ref object tracking clicked marker
 * @param {Function} params.onMarkerMouseover - Callback function triggered when mouse hovers over a marker
 * @param {Function} params.onMarkerMouseout - Callback function triggered when mouse leaves a marker
 * @param {React.MutableRefObject} params.markersRef - Ref object containing all marker instances
 *
 * @returns {Object} Object containing marker event handlers
 * @returns {Function} returns.spider_click - Internal click handler for markers
 * @returns {Function} returns.mouseover - Internal mouseover handler for markers
 * @returns {Function} returns.mouseout - Internal mouseout handler for markers
 * @returns {Function} returns.mousedown - Internal mousedown handler for markers
 * @returns {Function} returns.mouseup - Internal mouseup handler for markers
 */
const useMarkerEvents = _ref => {
  let {
    onMarkerClick,
    enableAdvancedMarkers,
    enabledLocationIds,
    selectedLocation,
    gMaps,
    theme,
    defaultMarkerIcon,
    onMarkerMouseover,
    onMarkerMouseout,
    markersRef
  } = _ref;
  const handleInternalMarkerMouseover = (0, _react.useCallback)(_ref2 => {
    let {
      marker,
      meta
    } = _ref2;
    if (enableAdvancedMarkers) {
      meta.isHovered = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
    onMarkerMouseover({
      marker,
      meta
    });
  }, [enableAdvancedMarkers, onMarkerMouseover, enabledLocationIds, selectedLocation, gMaps, theme, defaultMarkerIcon]);
  const handleInternalMarkerMouseout = (0, _react.useCallback)(_ref3 => {
    let {
      marker,
      meta
    } = _ref3;
    if (enableAdvancedMarkers) {
      meta.isHovered = false;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
    onMarkerMouseout({
      marker,
      meta
    });
  }, [enableAdvancedMarkers, onMarkerMouseout, enabledLocationIds, selectedLocation, gMaps, theme, defaultMarkerIcon]);
  const handleInternalMarkerMousedown = (0, _react.useCallback)(_ref4 => {
    let {
      marker,
      meta
    } = _ref4;
    if (enableAdvancedMarkers) {
      meta.isFocused = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
  }, [enableAdvancedMarkers, enabledLocationIds, selectedLocation, gMaps, theme, defaultMarkerIcon]);
  const handleInternalMarkerMouseup = (0, _react.useCallback)(_ref5 => {
    let {
      marker,
      meta
    } = _ref5;
    if (enableAdvancedMarkers) {
      var _context, _context2;
      const previouslyClickedMarker = ((_context = markersRef.current) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _filter.default)(_context), _context))?.(_ref6 => {
        let {
          meta
        } = _ref6;
        return meta.isPressed;
      }) || [];
      if (previouslyClickedMarker.length > 0) {
        (0, _forEach.default)(previouslyClickedMarker).call(previouslyClickedMarker, _ref7 => {
          let {
            marker,
            meta
          } = _ref7;
          meta.isPressed = false;
          (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
        });
      }
      meta.isFocused = false;
      meta.isPressed = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
    onMarkerClick({
      marker,
      meta
    });
  }, [enableAdvancedMarkers, enabledLocationIds, selectedLocation, gMaps, theme, defaultMarkerIcon]);
  const handleInternalMarkerClick = (0, _react.useCallback)(_ref8 => {
    let {
      marker,
      meta
    } = _ref8;
    if (enableAdvancedMarkers) {
      var _context3, _context4;
      const previouslyClickedMarker = ((_context3 = markersRef.current) == null ? void 0 : (0, _bind.default)(_context4 = Function.call).call(_context4, (0, _filter.default)(_context3), _context3))?.(_ref9 => {
        let {
          meta
        } = _ref9;
        return meta.isPressed;
      }) || [];
      if (previouslyClickedMarker.length > 0) {
        (0, _forEach.default)(previouslyClickedMarker).call(previouslyClickedMarker, _ref10 => {
          let {
            marker,
            meta
          } = _ref10;
          meta.isPressed = false;
          (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
        });
      }
      meta.isFocused = false;
      meta.isPressed = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
    onMarkerClick({
      marker,
      meta
    });
  }, [enableAdvancedMarkers, onMarkerClick, enabledLocationIds, selectedLocation, gMaps, theme, defaultMarkerIcon, markersRef]);
  return {
    spider_click: handleInternalMarkerClick,
    mouseover: handleInternalMarkerMouseover,
    mouseout: handleInternalMarkerMouseout,
    mousedown: handleInternalMarkerMousedown,
    mouseup: handleInternalMarkerMouseup
  };
};
exports.useMarkerEvents = useMarkerEvents;